module.exports = __webpack_public_path__ + "static/273713_medium-efea1d22c4504a4358345095f7a46e82.mp4";